<template>
  <line
    :x1 = "(num * getSprinklerSpacing * getMagScale) + offset"
    :y1 = "0"
    :x2 = "(num * getSprinklerSpacing * getMagScale) + offset"
    :y2 = "getSprinklerHeight"
    :style = "getLineColor"
    stroke-linecap = "round"
    stroke-width = "4"
    @mousedown="handleMouseDown"
    class="sprinkler-line"
  />
</template>

<script>
import { useSegmentStore } from '@/store/SegmentStore';
import { useInputStore } from '@/store/InputStore';

export default {
  name: 'CompositeSprinkler',
  props: [
    'num',
    'line',
    'sprinklers',
  ],
  data () {
    return {
      startX: 0,
      startSpacing: 0,
      mouseDir: 0,
      currentDirection: 0
    };
  },
  computed: {
    getLineColor () {
      return 'stroke:' + 'rgb(0,0,0)';
    },
    getSprinklerHeight () {
      const pipeEditor = document.getElementById('pipe-editor');
      if (!pipeEditor) { return - 15; }
      return -15 * (pipeEditor.clientHeight / 300);
    },
    getSprinklerSpacing () {
      return useInputStore().getSprinklerSpacing;
    },
    getMagScale () {
      return useSegmentStore().getMagScale;
    },
    offset () {
      return useInputStore().getLeftOffset * this.getMagScale;
    }
  },
  methods: {
    handleMouseDown (e) {
      this.startX = e.clientX;
      this.currentDirection = this.startX;
      this.startSpacing = useInputStore().getSprinklerSpacing.valueOf();
      document.body.addEventListener('mousemove', this.handleMouseMove);
      document.body.addEventListener('mouseup', this.handleMouseUp);
    },
    handleMouseMove (e) {
      let currentX = e.clientX;
      this.mouseDir = (currentX <= this.currentDirection) ? -1 : 1;
      this.currentDirection = currentX;
      let diff = this.startX - (currentX);
      if (diff % 10 === 0) {
        let newSpacing = this.startSpacing + this.mouseDir;
        useInputStore().setSprinklerSpacing(newSpacing);
        this.startSpacing += this.mouseDir;
      }
    },
    handleMouseUp () {
      document.body.removeEventListener('mousemove', this.handleMouseMove);
      document.body.removeEventListener('mouseup', this.handleMouseUp);
      this.mouseDir = 0;
      this.currentDirection = 0;
      useInputStore().sprinklerCalc();
    }
  }
};
</script>

<style scoped>
.sprinkler-line {
  cursor: ew-resize;
  pointer-events: all;
}
</style>